export class HelpSlides {
    public slides: HelpSlide[];

    constructor() {
        this.slides = [];
    }
}

export class HelpSlide {
    public title: string = '';
    public text: string = '';
    public image: string = '';
    
    constructor(_title: string = '', _text: string = '') {
        this.title = _title;
        this.text = _text;
    }
}
